import { render, staticRenderFns } from "./drop-ginga.vue?vue&type=template&id=18874692&scoped=true&"
import script from "./drop-ginga.vue?vue&type=script&lang=js&"
export * from "./drop-ginga.vue?vue&type=script&lang=js&"
import style0 from "./drop-ginga.vue?vue&type=style&index=0&id=18874692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18874692",
  null
  
)

export default component.exports